// extracted by mini-css-extract-plugin
module.exports = {"root":"_2FHIj","left":"_3p8H9","right":"_2UhPy","small":"_23qq-","normal":"_2zkZN"};